// extracted by mini-css-extract-plugin
export default {"footer-container":"footer_footer-container__7jT+A","socials-container":"footer_socials-container__aT8OO","copyright":"footer_copyright__coLx4"};